/**
 * lh-cart-shipping.js
 * Lolahome — Calculadora de Frete no carrinho lateral (Velour Theme)
 *
 * Fluxo:
 *  1. Usuário digita o CEP (formatado 00000-000 automaticamente)
 *  2. Clica em "Calcular" → busca o estado via ViaCEP
 *  3. Busca fretes disponíveis via /cart/shipping_rates.json
 *  4. Exibe a opção mais barata e a mais rápida
 *  5. Atualiza a barra de frete grátis (global no topo do drawer)
 *
 * Configuração:
 *  window.lhShippingConfig é injetado pelo snippet lh-cart-shipping.liquid
 */

(function () {
  'use strict';

  const STORAGE_KEY = 'lh_shipping_estimate';

  // ─── Config (injetado via Liquid) ──────────────────────────────────────────
  const config = window.lhShippingConfig || { cartTotal: 0, freeShippingStates: '', globalFreeShipping: 0, texts: {} };
  const texts = config.texts || {};

  // ─── Thresholds de frete grátis por estado ──────────────────────────────────
  // Formato da setting: "150 -> SP,RJ\n200 -> MG,ES"
  function buildFreeShippingMap(raw) {
    const map = {};
    if (!raw) return map;
    raw.split('\n').forEach(function (line) {
      const parts = line.split('->');
      if (parts.length !== 2) return;
      const amount = parseInt(parts[0].trim(), 10);
      const states = parts[1].split(',').map(function (s) { return s.trim().toUpperCase(); });
      states.forEach(function (uf) { map[uf] = amount; });
    });
    return map;
  }

  const freeShippingMap = buildFreeShippingMap(config.freeShippingStates);

  function getFreeShippingThreshold(uf) {
    return freeShippingMap[uf] || config.globalFreeShipping || 0;
  }

  // ─── Cache (localStorage) ──────────────────────────────────────────────────
  function loadCache() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || null; }
    catch { return null; }
  }

  function saveCache(data) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }

  // ─── Formatação de CEP ─────────────────────────────────────────────────────
  function formatZip(value) {
    const digits = value.replace(/\D/g, '').slice(0, 8);
    return digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
  }

  function rawZip(value) {
    return value.replace(/\D/g, '');
  }

  // ─── DOM helpers ───────────────────────────────────────────────────────────
  function getInput()  { return document.getElementById('lh-shipping-zip'); }
  function getBtn()    { return document.getElementById('lh-shipping-btn'); }
  function getError()  { return document.getElementById('lh-shipping-error'); }
  function getResult() { return document.getElementById('lh-shipping-result'); }

  function showError(msg) {
    const el = getError();
    if (!el) return;
    el.textContent = msg;
    el.style.display = msg ? '' : 'none';
    // Quando exibe erro, limpa o resultado anterior
    if (msg) {
      const result = getResult();
      if (result) result.innerHTML = '';
    }
  }

  function showResult(html) {
    const el = getResult();
    if (!el) return;
    el.innerHTML = html;
    // Esconde a área de erro sem limpar o resultado
    const errEl = getError();
    if (errEl) { errEl.textContent = ''; errEl.style.display = 'none'; }
  }

  function setButtonLoading(loading) {
    const btn = getBtn();
    if (!btn) return;
    btn.disabled = loading;
    btn.textContent = loading ? (texts.buttonWorking || 'Calculando...') : (texts.button || 'Calcular');
  }

  // ─── Barra de frete grátis ─────────────────────────────────────────────────
  // Usa #lh-free-shipping-bar (nosso elemento próprio, independente do setting do tema)

  function renderBar(bar, threshold, cartTotal, ufLabel) {
    const remaining  = Math.max(0, threshold - cartTotal);
    const percentage = Math.min(100, Math.round((cartTotal / threshold) * 100));

    const textEl = bar.querySelector('.wt-free-shipping-bar__text');
    if (textEl) {
      if (remaining <= 0) {
        var freeText = (texts.freeResult || 'Você ganhou frete grátis!');
        textEl.textContent = freeText.replace('[state]', ufLabel || '');
      } else {
        const formatted = formatMoney(remaining * 100);
        var remainingText = (texts.freeRemaining || 'Faltam [remaining_value] para frete grátis');
        textEl.textContent = remainingText
          .replace('[remaining_value]', formatted)
          .replace('[state]', ufLabel || '');
      }
    }

    const fillEl = bar.querySelector('.wt-progress-bar__fill');
    if (fillEl) fillEl.style.width = percentage + '%';

    bar.style.display = '';
  }

  function updateFreeShippingBar(uf, cartTotal) {
    const bar = document.getElementById('lh-free-shipping-bar');
    if (!bar) return;

    const stateThreshold  = getFreeShippingThreshold(uf);
    const globalThreshold = config.globalFreeShipping;
    const threshold       = stateThreshold || globalThreshold;

    if (!threshold) return; // sem configuração, mantém oculta

    renderBar(bar, threshold, cartTotal, stateThreshold ? uf : null);
  }

  // Formata centavos para reais (usa o formato Shopify se disponível)
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, 'R$ {{amount}}');
    }
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  // ─── ViaCEP: busca estado pelo CEP ────────────────────────────────────────
  function fetchProvince(zip) {
    return fetch('https://viacep.com.br/ws/' + zip + '/json', { cache: 'force-cache' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.erro) throw new Error('CEP não encontrado');
        return data.uf; // UF de 2 letras (SP, RJ, etc.)
      });
  }

  // ─── Shopify: busca fretes disponíveis ────────────────────────────────────
  function fetchShippingRates(zip, province) {
    const url = '/cart/shipping_rates.json'
      + '?shipping_address%5Bzip%5D=' + zip
      + '&shipping_address%5Bcountry%5D=Brazil'
      + '&shipping_address%5Bprovince%5D=' + province;

    return fetch(url).then(function (r) { return r.json(); });
  }

  // ─── Formata prazo de entrega ─────────────────────────────────────────────
  function formatDays(rate) {
    const days = rate.delivery_days;
    if (!days) return '';
    if (Array.isArray(days)) {
      return days[0] === days[1] ? days[0] + ' dias úteis' : days[0] + '-' + days[1] + ' dias úteis';
    }
    return days + ' dias úteis';
  }

  // ─── Constrói HTML do resultado ───────────────────────────────────────────
  function buildResultHTML(rates, zip, province) {
    if (!rates || rates.length === 0) {
      return '<p class="lh-shipping__result-none">' + (texts.resultNone || 'Nenhuma opção de frete encontrada para este CEP.') + '</p>';
    }

    // Filtra "Retire na loja"
    const available = rates.filter(function (r) {
      return !r.presentment_name.toLowerCase().includes('retire') &&
             !r.presentment_name.toLowerCase().includes('retirada');
    });

    if (available.length === 0) {
      return '<p class="lh-shipping__result-none">' + (texts.resultNone || 'Nenhuma entrega disponível para este CEP.') + '</p>';
    }

    // Menor preço
    const cheaper = available.reduce(function (a, b) {
      return parseFloat(a.price) <= parseFloat(b.price) ? a : b;
    });

    // Mais rápido (menor delivery_days máximo)
    const faster = available.reduce(function (a, b) {
      const daysA = Array.isArray(a.delivery_days) ? a.delivery_days[1] : (a.delivery_days || 99);
      const daysB = Array.isArray(b.delivery_days) ? b.delivery_days[1] : (b.delivery_days || 99);
      return daysA <= daysB ? a : b;
    });

    const isSame = cheaper.name === faster.name;
    const cheaperIsFree = parseFloat(cheaper.price) === 0;

    let html = '<ul class="lh-shipping__rate-list">';

    if (cheaperIsFree) {
      html += '<li class="lh-shipping__rate lh-shipping__rate--free">'
           + '<span class="lh-shipping__rate-name">' + cheaper.presentment_name + '</span>'
           + '<span class="lh-shipping__rate-price">Grátis</span>';
      if (formatDays(cheaper)) html += '<span class="lh-shipping__rate-days">em ' + formatDays(cheaper) + '</span>';
      html += '</li>';
    } else {
      html += '<li class="lh-shipping__rate">'
           + '<span class="lh-shipping__rate-name">' + cheaper.presentment_name + '</span>'
           + '<span class="lh-shipping__rate-price">' + formatMoney(parseFloat(cheaper.price) * 100) + '</span>';
      if (formatDays(cheaper)) html += '<span class="lh-shipping__rate-days">em ' + formatDays(cheaper) + '</span>';
      html += '</li>';
    }

    if (!isSame) {
      const fasterIsFree = parseFloat(faster.price) === 0;
      html += '<li class="lh-shipping__rate">'
           + '<span class="lh-shipping__rate-name">' + faster.presentment_name + '</span>'
           + '<span class="lh-shipping__rate-price">' + (fasterIsFree ? 'Grátis' : formatMoney(parseFloat(faster.price) * 100)) + '</span>';
      if (formatDays(faster)) html += '<span class="lh-shipping__rate-days">em ' + formatDays(faster) + '</span>';
      html += '</li>';
    }

    html += '</ul>'
         + '<p class="lh-shipping__checkout-hint">mais opções de frete no checkout</p>';

    // Salva no cache incluindo o HTML do resultado (evita re-fetch a cada re-render)
    saveCache({ zip: rawZip(zip), province: province, resultHtml: html });

    // Atualiza a barra de frete grátis com o estado detectado e total atual
    updateFreeShippingBar(province, config.cartTotal);

    return html;
  }

  // ─── Busca total atual do carrinho via API ────────────────────────────────
  // Necessário porque config.cartTotal é injetado pelo Liquid na carga inicial
  // e não se atualiza quando o drawer é re-renderizado via innerHTML.
  async function getCurrentCartTotal() {
    try {
      const resp = await fetch('/cart.js');
      const cart = await resp.json();
      return cart.total_price / 100; // Shopify retorna em centavos
    } catch {
      return config.cartTotal; // fallback para o valor inicial
    }
  }


  // ─── Handler principal: clique em Calcular ────────────────────────────────
  async function handleCalculate() {
    const input = getInput();
    if (!input) return;

    const zip = rawZip(input.value);

    if (zip.length < 8) {
      showError(texts.errorCep || 'Por favor, informe um CEP válido (8 dígitos).');
      return;
    }

    setButtonLoading(true);
    showError('');
    showResult('');

    try {
      config.cartTotal = await getCurrentCartTotal();

      const cache = loadCache();

      let province;
      if (cache && cache.zip === zip) {
        province = cache.province;
      } else {
        province = await fetchProvince(zip);
      }

      const data = await fetchShippingRates(zip, province);
      const html = buildResultHTML(data.shipping_rates, zip, province);
      showResult(html);

    } catch (err) {
      if (err.message === 'CEP não encontrado') {
        showError(texts.cepNotFound || 'CEP não encontrado. Verifique e tente novamente.');
      } else {
        showError(texts.resultError || 'Não foi possível calcular o frete. Tente novamente.');
        console.error('[LH Shipping] Erro:', err);
      }
    } finally {
      setButtonLoading(false);
    }
  }

  // ─── Event delegation no document ────────────────────────────────────────
  // (sobrevive a re-renders do cart drawer)
  let listenersAttached = false;

  function attachListeners() {
    if (listenersAttached) return;
    listenersAttached = true;

    // Máscara do CEP ao digitar
    document.addEventListener('input', function (e) {
      if (e.target.id !== 'lh-shipping-zip') return;
      const cursor = e.target.selectionStart;
      const raw = rawZip(e.target.value);
      const formatted = formatZip(raw);
      e.target.value = formatted;
      // Reposiciona cursor após a formatação
      const diff = formatted.length - e.target.value.length;
      try { e.target.setSelectionRange(cursor + diff, cursor + diff); } catch (_) {}
    });

    // Enter no campo dispara o cálculo
    document.addEventListener('keydown', function (e) {
      if (e.target.id !== 'lh-shipping-zip') return;
      if (e.key === 'Enter') handleCalculate();
    });

    // Clique no botão Calcular
    document.addEventListener('click', function (e) {
      if (e.target.id === 'lh-shipping-btn' || e.target.closest('#lh-shipping-btn')) {
        handleCalculate();
      }
    });
  }

  // ─── Restaura estado completo após re-render ou reload ───────────────────
  // - Atualiza a barra com o total ATUAL do carrinho (via API)
  // - Restaura o CEP e o resultado em cache (sem re-fetch de frete)
  // - Reabre o acordeão se havia um CEP calculado
  function clearShippingCache() {
    localStorage.removeItem(STORAGE_KEY);
    showResult('');
    var input = getInput();
    if (input) input.value = '';
  }

  function showDefaultBar() {
    var bar = document.getElementById('lh-free-shipping-bar');
    if (!bar) return;
    var textEl = bar.querySelector('.wt-free-shipping-bar__text');
    var fillEl = bar.querySelector('.wt-progress-bar__fill');
    if (textEl) textEl.textContent = texts.freeBarCta || 'Calcule o frete para conferir o Frete Grátis!';
    if (fillEl) fillEl.style.width = '0%';
    bar.style.display = '';
  }

  async function restoreShippingState() {
    const cartTotal = await getCurrentCartTotal();
    config.cartTotal = cartTotal;

    // Carrinho vazio: limpa cache (mesmo se o input não existe no DOM)
    if (cartTotal <= 0) {
      localStorage.removeItem(STORAGE_KEY);
      return;
    }

    if (!document.getElementById('lh-shipping-zip')) return;

    const cache = loadCache();

    if (!cache) {
      // Sem CEP calculado: mostra barra padrão ou esconde conforme config
      if (config.showBarWithoutCep) {
        showDefaultBar();
      } else {
        var bar = document.getElementById('lh-free-shipping-bar');
        if (bar) bar.style.display = 'none';
      }
      return;
    }

    // Atualiza a barra com total atual e estado em cache
    updateFreeShippingBar(cache.province, cartTotal);

    // Restaura o CEP no input
    const input = getInput();
    if (input) input.value = formatZip(cache.zip);

    // Re-calcula o frete com o total atualizado do carrinho
    try {
      const data = await fetchShippingRates(cache.zip, cache.province);
      const html = buildResultHTML(data.shipping_rates, cache.zip, cache.province);
      showResult(html);
    } catch (_) {
      if (cache.resultHtml) showResult(cache.resultHtml);
    }
  }

  // ─── Observa re-renders do cart drawer ────────────────────────────────────
  function observeCartDrawer() {
    const cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer) return;

    let debounce;
    new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        restoreShippingState();
      }, 150);
    }).observe(cartDrawer, { childList: true, subtree: false });
  }

  // ─── Inicialização ────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    attachListeners();
    setTimeout(restoreShippingState, 150);
    observeCartDrawer();
  });

})();
